'use strict';
(function($){
    /*
     * Vetology.floatingButtonLink widget
     *
     * @description A floating element with a link to the contact us form page
     *
     * @options					See description for each option
     *
     * @method	See description above each method
     */
    $.widget(
        'Vetology.floatingButtonLink',
        {
            options: {
                icon: "",
                link: ""
            },
            /*
             * Vetology.FloatingButtonLink._create
             *
             * @description Vetology.FloatingButtonLink constructor
             *
             * @return NULL
             *
             */
            "_create": function(){
                var o = this;
                if(o.options.icon !== "" && o.options.link !== ""){
                    o.button_element = $('<div class="floating-button-link" tabindex="0" data-trigger="hover"  data-html="true" data-placement="left" data-toggle="popover" data-container="body" data-content="Contact us"><a href="' + o.options.link + '" target="_blank"><div class="icon-wrapper"><i class="' + o.options.icon + '"></i></div></a></div>');
                    o.button_element.popover();
                    $(o.element).append(o.button_element);
                }
                else{
                    o.error_element = $('<div>Error loading</div>');
                    $(o.element).append();
                }
            },
            /*
             * Vetology.FloatingButtonLink._init
             *
             * @description	Initializes the Vetology.FloatingButtonLink
             *
             * @return NULL
             *
             */
            "_init": function(){
                var o = this;
            }
        }
    );
})(jQuery);